module.exports = __webpack_public_path__ + "static/media/schedule.13883cbc.jpg";